import UserDownloadsList from "@entities/downloads/ui/DownloadsUsersList";
import { Button } from "@shared/ui/Button";
import { Dropdown } from "antd";
import { Download } from "lucide-react";
import { useHeaderDropdownStore } from "../../lib/store";
import styles from "./Header.module.scss";

export function Header() {
  const { activeDropdown, setActiveDropdown } = useHeaderDropdownStore();

  return (
    <div className={styles.headerContent}>
      <div className={styles.headerActions}>
        <Dropdown
          menu={{}}
          trigger={["click"]}
          open={activeDropdown === "downloads"}
          onOpenChange={(open) => setActiveDropdown(open ? "downloads" : null)}
          dropdownRender={() => (
            <div className={styles.dropdownOverlay}>
              <div className={styles.dropdownHeader}>
                <h3>Recent downloads</h3>
                <span className={styles.dropdownBadge}>Last 30 days</span>
              </div>
              <div className={styles.dropdownContent}>
                <UserDownloadsList />
              </div>
            </div>
          )}
        >
          <Button
            type="text"
            icon={<Download size={19} strokeWidth={2.2} />}
            className={`${styles.actionButton} ${
              activeDropdown === "downloads" ? styles.active : ""
            }`}
            title="Downloads"
            style={{ padding: "0px !important", height: "max-content" }}
          />
        </Dropdown>
      </div>
    </div>
  );
}
